import React from 'react'
import ModalYesNo from './ModalYesNo'

export default function DeleteRowModal() {
  return (
    <ModalYesNo>
      Удалить запись?
    </ModalYesNo>
  )
}